<template>
  <div class="realTimeStatusPage mainPageBg">
    <div class="leftMenuBox">
      <TreeMenu @getActiveItem="getActiveItem" :pageName="'动力系统'" />
    </div>
    <div class="contentBox">
      <div
        class="leftBox"
        :style="{
          width:
            activeTree.type == '项目' || activeTree.type == '区域资产'
              ? '100%'
              : '75%',
        }"
      >
        <StateCenterCom :activeTree="activeTree" />
      </div>
      <div
        class="rightBox"
        v-if="activeTree.type != '项目' && activeTree.type != '区域资产'"
      >
        <ElevatorArchives :activeTree="activeTree"/>
      </div>
    </div>
  </div>
</template>

<script>
import ElevatorArchives from "@/components/zixitong/dynamicalSystem/ElevatorArchives.vue";
import StateCenterCom from "@/components/zixitong/dynamicalSystem/StateCenterCom.vue";
import TreeMenu from "@/components/zixitong/TreeMenu";
export default {
  components: {
    StateCenterCom,
    ElevatorArchives,
    TreeMenu,
  },
  data() {
    return {
      activeTree: {},
    };
  },
  methods: {
    getActiveItem(data) {
      this.activeTree = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.realTimeStatusPage {
  @include setFlexBetween;
  .leftMenuBox {
    @include setMenuWH;
  }
  .contentBox {
    @include setCenterWH;
    @include setFlexBetween;
    .leftBox {
      width: 75%;
      height: 100%;
    }
    .rightBox {
      width: 24%;
      height: 100%;
    }
  }
}
</style>
